export default __webpack_public_path__ + "static/media/83.733a9649.jpg";